import React from 'react';
import { useFxRates, convertFromTRY, formatEstimate } from '../context/FxRatesContext';

/**
 * Renders the estimated EUR + USD equivalent of a TRY price, e.g.
 *   "~€72 · ~$78"
 *
 * The actual customer charge stays in TRY via PayTR — this is shown
 * purely as an indicative conversion for international visitors.
 *
 * Props:
 *   amount   number   – TRY amount to convert (defaults to 0)
 *   className string  – Tailwind classes for the wrapper
 *   separator string  – string between the two currencies (default " · ")
 */
const PriceEstimate = ({ amount, className = '', separator = ' · ' }) => {
  const { rates, loaded } = useFxRates();
  if (!loaded || !amount || amount <= 0) return null;

  const eur = formatEstimate(convertFromTRY(amount, rates.EUR));
  const usd = formatEstimate(convertFromTRY(amount, rates.USD));
  if (!eur && !usd) return null;

  return (
    <span
      className={`text-xs text-gray-500 ${className}`}
      data-testid="price-estimate"
      title="Approximate conversion. You will be charged in TRY."
    >
      {eur && <span>~€{eur}</span>}
      {eur && usd && <span aria-hidden="true">{separator}</span>}
      {usd && <span>~${usd}</span>}
    </span>
  );
};

export default PriceEstimate;
